const showHidePrivacyPolicyCheckboxBasedOnCountrySelect = require("./showHidePrivacyPolicyCheckboxBasedOnCountrySelect");

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {void}
 */
module.exports = function whenCountrySelectUpdates(countrySelect) {
    showHidePrivacyPolicyCheckboxBasedOnCountrySelect(countrySelect);
}